import DateTimeField from "../DateTimeField";
import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ErrorTooltipIcon from "../ErrorTooltipIcon";

const TextFieldWithErrorTooltip = ({ error, helperText, InputProps, ...props }) => {
  const isDesktopPointer = useMediaQuery("(hover: hover) and (pointer: fine)");
  const message = error && typeof helperText === "string" ? helperText : null;

  const mergedInputProps = {
    ...InputProps,
    endAdornment: (
      <>
        {InputProps?.endAdornment}
        {message && isDesktopPointer && (
          <InputAdornment position="end">
            <ErrorTooltipIcon message={message} />
          </InputAdornment>
        )}
      </>
    ),
  };

  const FieldComponent = ["date", "datetime-local", "time"].includes(props.type) ? DateTimeField : TextField;

  return (
    <FieldComponent
      {...props}
      error={Boolean(error)}
      helperText={helperText}
      InputProps={mergedInputProps}
    />
  );
};

export default TextFieldWithErrorTooltip;

